import * as React from 'react';

import { IContext, context } from './context';

export function useFiltersContext(): IContext {
  return React.useContext(context);
}
